<template src="../templates/normal_fcont_187.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'
import FuncSearchGallery from '../components/FuncSearchGallery'
import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import CreatorProfileVosges from '../components/CreatorProfileVosges'
import PrintButton from '../components/PrintButton'
import InfoMachineTranslation from '../components/InfoMachineTranslation'
import AppDownloadPhotoPlus from '../components/AppDownloadPhotoPlus'
import { Carousel,Slide } from 'uiv'

export default {
  name: 'app',
  components: {
    FuncSearchGallery,LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,CreatorProfileVosges,
    PrintButton,InfoMachineTranslation,
    AppDownloadPhotoPlus
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['187-1'],
      meta: [
        { name: 'description', content: this.$store.state.messages.messages['187-3']}
      ]
    };
  }
  
};
</script>
<style >
</style>

